import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Layout } from "antd";
import Sider from "antd/es/layout/Sider";
import { Content } from "antd/es/layout/layout";
import styles from "./Dashboard.module.css";
import Security from "../Settings/Security/Security";
import UserProfile from "../Settings/UserProfile/UserProfile";
import SwitchDropdown from "./SwitchDropdown/SwitchDropdown";
import TopBar from "./TopBar/TopBar";
import Overview from "../Overview/Overview";
import homeIcon from "../../assets/img/new/homeIcon.png";
import homeIconFill from "../../assets/img/new/homeIconFill.png";
import profileIcon from "../../assets/img/new/profileIcon.png";
import profileIconFill from "../../assets/img/new/profileIconFill.png";
import securityIcon from "../../assets/img/new/securityIcon.png";
import securityIconFill from "../../assets/img/new/securityIconFill.png";
import Activity from "../Activity/Activity";
import { MdHistory, MdOutlineHistory } from "react-icons/md";


const Dashboard: React.FC = () => {
  const { section } = useParams<{ section?: string }>();
  const [selectedItem, setSelectedItem] = useState<string>(section || "Home");
  const [breadcrumbsItems, setBreadcrumbsItems] = useState<string[]>([]);
  const [isAgencyUser, setIsAgencyUser] = useState<boolean>(false);

  // Update selectedItem if section param changes
  useEffect(() => {
    if (section) {
      setSelectedItem(section);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [section]);

  useEffect(() => {
    setBreadcrumbsItems([selectedItem]);

    // Get user data from localStorage
    const chUserDataCookie = localStorage.getItem("ch_user_data");

    if (chUserDataCookie) {
      try {
        const userData = JSON.parse(chUserDataCookie);
        const agencyStatus = userData?.userGroup === 'Agency';

        setIsAgencyUser(agencyStatus);
      } catch (error) {
        console.error('Error parsing user data:', error);
      }
    } else {
      console.log('No ch_user_data found in localStorage');
    }
  }, [selectedItem]);


  const renderContent = () => {
    switch (selectedItem) {
      case "Home":
        return <Overview />;
      case "Payments":
        return <div>Payments Content</div>;
      case "Profile":
        return <UserProfile />;
      case "Security":
        return <Security />;
      case "Activity":
        return <Activity />;
      default:
        return <Overview />;
    }
  };

  // Style variables based on user group
  const getNavItemStyle = (itemName: string) => {
    if (!isAgencyUser) return {};
    
    return {
      borderLeft: "none",
      ...(selectedItem === itemName && {
        backgroundColor: "#fef7ed"
      })
    };
  };

  const getTextStyle = (itemName: string) => {
    if (!isAgencyUser) {
      return { 
        color: "black" 
      };
    }
    
    return {
      color: selectedItem === itemName ? "#de7c00" : "black"
    };
  };

  const getIconClass = (itemName: string) => {
    // Only use navIconFill for agency users
    if (isAgencyUser && selectedItem === itemName) {
      return styles.navIconFill;
    }
    return "";
  };

  return (
    <Layout style={{ height: "100vh", backgroundColor: "#EEEFF4" }}>
      <Sider
        width='6rem'
        style={{
          backgroundColor: "white",
        }}
      >
        <div>
          <ul className={`${styles.menuList} ${isAgencyUser ? styles.agencyMenu : styles.regularMenu}`}>
            <SwitchDropdown />
            <li
              onClick={() => setSelectedItem("Home")}
              style={getNavItemStyle("Home")}
            >
              <img
                src={selectedItem === "Home" ? homeIconFill : homeIcon}
                alt="Home"
                className={getIconClass("Home")}
              />
              <p style={getTextStyle("Home")}>Home</p>
            </li>
            <li
              onClick={() => setSelectedItem("Profile")}
              style={getNavItemStyle("Profile")}
            >
              <img
                src={selectedItem === "Profile" ? profileIconFill : profileIcon}
                alt="profile"
                className={getIconClass("Profile")}
              />
              <p style={getTextStyle("Profile")}>Profile</p>
            </li>
            <li
              onClick={() => setSelectedItem("Security")}
              style={getNavItemStyle("Security")}
            >
              <img
                src={selectedItem === "Security" ? securityIconFill : securityIcon}
                alt="security"
                className={getIconClass("Security")}
              />
              <p style={getTextStyle("Security")}>Security</p>
            </li>
            <li
              onClick={() => setSelectedItem("Activity")}
              style={getNavItemStyle("Activity")}
            >
              {selectedItem === "Activity" ? (
                <MdHistory size={28} color={isAgencyUser ? "#de7c00" : "#1D4ED8"} />
              ) : (
                <MdOutlineHistory size={28} color="#000" />
              )}
              <p style={getTextStyle("Activity")}>Activity</p>
            </li>
          </ul>
        </div>
      </Sider>

      <Layout style={{ marginLeft: "25px" }}>
        <TopBar breadcrumbsItems={breadcrumbsItems} />
        <Content style={{ backgroundColor: "#EEEFF4" }}>
          {renderContent()}
        </Content>
      </Layout>
    </Layout>
  );
};

export default Dashboard;